import { Link } from 'react-router-dom';
import { getHubItemHref, isExternalHubHref } from '../helper/hubItemHref';

const linkClassName =
  'group flex h-full w-full flex-col justify-between no-underline text-inherit cursor-pointer';

export function HubListingCardLink({ item, className = linkClassName, children }) {
  const href = getHubItemHref(item);

  if (!href) {
    return <div className={className}>{children}</div>;
  }

  if (isExternalHubHref(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}
